<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
      @changeInvalid="
        initPager()
        ini()
      "
      @changeProductName="
        initPager()
        ini()
      "
    >
      <template #searchDetailArea>
        <div class="px-9 py-7" style="display: flex">
          <div style="width: 360px" class="mr-9">
            <InputFormNew
              v-model="searchDetailInfo.line1"
              :detail="searchDetail.line1"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
          <div style="width: 200px" class="mr-9 mt-12">
            <InputFormNew
              v-model="searchDetailInfo.line2"
              :detail="searchDetail.line2"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="4"
              :contentsCols="8"
              @offSearchHeaderInfoInvalidData="offSearchHeaderInfoInvalidData"
            >
            </InputFormNew>
          </div>
          <div style="width: 450px" class="mt-12">
            <InputFormNew
              v-model="searchDetailInfo.line3"
              :detail="
                !authority.isOutsideStaff
                  ? searchDetail.line3
                  : searchDetail.line3_OutsideStaff
              "
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :summary="summary"
          :historyList="historyList"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :pagerKey="pagerKey"
          @rowDialogMethodCommon="rowDialogMethodCommon"
          @pageMove="ini"
          ref="historyListComponent"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>

    <LoadingDialog
      v-model="dialogs.loading"
      :title="$t('loading.loading_loading-operation')"
      :recItems="dialogs.loading.rowItems"
      :pageInfoData="dialogs.loading.pageInfoData"
      @complete="completeLoading"
    >
      <template #historyList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </LoadingDialog>

    <OrderDetailDialog
      v-model="dialogs.orderDetail"
      :title="$t('order.order_order-details')"
      width="80%"
      :recItems="dialogs.orderDetail.rowItems"
      :pageInfoData="dialogs.orderDetail.pageInfoData"
      @complete="completeOrderDetail"
    >
      <template #loadingHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
      <template #changeHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
          :isFooter="true"
          :isChangeHistory="true"
        >
        </HistoryList>
      </template>
    </OrderDetailDialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { commonUtil, supplierUtil, currencyUtil } from '@/util'

import { orderStatusHistory } from '@/config'

import detail from './detail'
import headers from './headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'

import { LoadingDialog, OrderDetailDialog } from '@/components/layouts/Dialogs'
import mutationTypes from '@/store/mutationTypes'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew,
    LoadingDialog,
    OrderDetailDialog
  },
  data: () => {
    return {
      pageTitle: 'common.common_loading-order-history',
      pagerKey: 'orderHistory',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: 'order.order_not-show-invalid-orders'
      },
      searchDetailInfo: {
        line1: {
          supplierName: [],
          withdrawDate: { start: '', end: '' },
          orderDate: { start: '', end: '' },
          completionDate: { start: '', end: '' },
          loadingDate: { start: '', end: '' }
        },
        line2: {
          withdrawStatus: {},
          loadingStatus: {},
          orderStatus: {
            value: orderStatusHistory.COMPLETE_STATUS.BEFORE_COMPLETE,
            label: orderStatusHistory.STATUS_HISTORY_LABEL.BEFORE_COMPLETE
          },
          createUser: {}
        },
        line3: {
          currency: { label: '', value: null },
          amountRange: {
            min: null,
            max: null
          },
          orderInfo: {
            orderNumber: ''
          },
          productInfo: {
            number: '',
            category: ''
          }
        }
      },

      summary: {},
      historyList: [],
      supplierNameList: [],
      clientInfoData: [],

      dialogs: {
        loading: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        },
        orderDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      }
    }
  },
  async created() {
    this.initPager()
    this.ini()
  },
  methods: {
    ...mapActions('Order', ['getOrderListFromApi']),
    ...mapGetters('Order', [
      'getOrderListFromState',
      'getMetaAndSummaryFromState',
      'getBulkOperationCompletedFromState'
    ]),
    ...mapGetters('Loading', ['getCancelCompletedFromState']),
    ...mapMutations('UI', [
      mutationTypes.UI_SET_PAGE,
      mutationTypes.UI_SET_PAGE_COUNT
    ]),
    ...mapActions('Common', ['setIsLoading']),

    async ini() {
      this.setIsLoading(true)
      supplierUtil.getSupplier() // SP01 仕入先一覧取得

      const getList = await this.getHistoryFromApi()
      const isNoData = !Object.keys(getList).length

      const [meta, summary] = this.getMetaAndSummaryFromState()
      this.summary = {
        totalRows: isNoData ? 0 : meta.totalRows,
        totalAmount: isNoData ? 0 : summary.totalAmount.amount,
        currencyId: isNoData ? '' : summary.totalAmount.currencyId,
        unitName: isNoData
          ? ''
          : currencyUtil.findCurrencyNameById(summary.totalAmount.currencyId)
              .unitName,
        currencyAmount: isNoData ? {} : summary.currencyAmount,
        matchedProductTotalAmount: isNoData
          ? {}
          : summary.matchedProductTotalAmount,
        matchedProducts: isNoData ? [] : summary.matchedProducts,
        matchedUnitName:
          isNoData || summary.matchedProducts.length === 0
            ? ''
            : currencyUtil.findCurrencyNameById(
                summary.matchedProductTotalAmount.currencyId
              ).unitName
      }

      this.historyList = isNoData
        ? []
        : getList
            .sort((a, b) => {
              const keyName = 'orderId'
              if (a[keyName] > b[keyName]) return -1
              if (a[keyName] < b[keyName]) return 1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
              return ele
            })
      this.setIsLoading(false)
    },

    formatObjectRequest(val) {
      return this.isObject(val) ? val.value : val
    },
    async getHistoryFromApi() {
      const line1 = this.searchDetailInfo.line1
      const line2 = this.searchDetailInfo.line2
      const line3 = this.searchDetailInfo.line3

      // Status
      const withdrawStatus = this.getWithdrawStatusSearchValue(
        line2.withdrawStatus
      )
      const loadingStatus = this.getLoadingStatusSearchValue(
        line2.loadingStatus
      )
      const orderStatus = this.getOrderStatusSearchValue(line2.orderStatus)

      // API call
      const ret = await this.getOrderListFromApi({
        invalidOrderDisplay: this.searchHeaderInfo.InvalidData ? 0 : 1,

        // orderDate
        orderStartDate: commonUtil.nullEmptyFormatNull(line1.orderDate.start),
        orderEndDate: commonUtil.nullEmptyFormatNull(line1.orderDate.end),
        // completionDate
        completedStartDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.start
        ),
        completedEndDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.end
        ),
        // withdrawDate
        paymentStartDate: commonUtil.nullEmptyFormatNull(
          line1.withdrawDate.start
        ),
        paymentEndDate: commonUtil.nullEmptyFormatNull(line1.withdrawDate.end),
        // loadingDate
        loadingStartDate: commonUtil.nullEmptyFormatNull(
          line1.loadingDate.start
        ),
        loadingEndDate: commonUtil.nullEmptyFormatNull(line1.loadingDate.end),

        orderPaymentStatusId: commonUtil.nullEmptyFormatNull(withdrawStatus),
        loadingStatusId: commonUtil.nullEmptyFormatNull(loadingStatus),
        orderStatusId: commonUtil.nullEmptyFormatNull(orderStatus),
        userId: commonUtil.nullEmptyFormatNull(
          this.formatObjectRequest(line2.createUser)
        ),

        supplierIds: commonUtil.nullEmptyFormatNull(
          line1.supplierName
            .map((supplierName) => {
              return supplierName.value
            })
            .join(',')
        ),
        currencyId: commonUtil.nullEmptyFormatNull(
          this.formatObjectRequest(line3.currency)
        ),
        priceMin: commonUtil.nullEmptyFormatNull(line3.amountRange.min),
        priceMax: commonUtil.nullEmptyFormatNull(line3.amountRange.max),
        searchKey: commonUtil.nullEmptyFormatNull(line3.orderInfo.orderNumber),
        productNumber: commonUtil.nullEmptyFormatNull(line3.productInfo.number),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line3.productInfo.category
        ),
        productName: commonUtil.nullEmptyFormatNull(
          this.searchHeaderInfo.productName
        ),
        matchedProductName: commonUtil.nullEmptyFormatNull(line3.productName),
        page: commonUtil.nullEmptyFormatNull(this.pageInfo[this.pagerKey].page)
      })

      const getList = this.getOrderListFromState()

      // 履歴の一括選択チェックボックスを解除する
      if (this.$refs.historyListComponent) {
        this.$refs.historyListComponent.changeAllCheckBox(false)
        this.$refs.historyListComponent.allChangeCheckBox = false
      }

      return getList
    },
    isObject(val) {
      return val && typeof val === 'object'
    },
    getWithdrawStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = orderStatusHistory.WITHDRAW_STATUS
      switch (status.value) {
        case statusList.BEFORE_WITHDRAW: {
          return 1
        }
        case statusList.AFTER_WITHDRAW: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getLoadingStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = orderStatusHistory.LOADING_STATUS
      switch (status.value) {
        case statusList.BEFORE_LOADING: {
          return 1
        }
        case statusList.AFTER_LOADING: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getOrderStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = orderStatusHistory.COMPLETE_STATUS
      switch (status.value) {
        case statusList.BEFORE_COMPLETE: {
          return 1
        }
        case statusList.AFTER_COMPLETE: {
          return 2
        }
        case statusList.CANCEL: {
          return 3
        }
        default: {
          return null
        }
      }
    },

    getBeforeCompleteFlgTmp(rec) {
      return rec.status == 1 && !rec.compDate
    },

    rowDialogMethodCommon(...args) {
      const [dialogName, info] = args

      switch (dialogName) {
        case 'reload': {
          this.ini()
          break
        }
        default:
          this.rowDialogMethodLoading(dialogName, ...info)
      }
    },
    rowDialogMethodCommonDataSet(type, rowItems, pageInfoData) {
      const dataInfo = this.dialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodLoading(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSet(type, rowItems, pageInfoData)
    },

    completeLoading() {
      this.ini()
      this.dialogs.loading.dialog = false
    },
    completeOrderDetail() {
      this.ini()
      this.dialogs.orderDetail.dialog = false
    },
    initPager() {
      this[mutationTypes.UI_SET_PAGE]({ index: 1, key: this.pagerKey })
      this[mutationTypes.UI_SET_PAGE_COUNT]({ length: 1, key: this.pagerKey })
    },
    offSearchHeaderInfoInvalidData() {
      this.searchHeaderInfo.InvalidData = false
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    ...mapGetters('UI', ['pageInfo']),
    cancelCompleted() {
      return this.getCancelCompletedFromState()
    },
    bulkOperationCompleted() {
      return this.getBulkOperationCompletedFromState()
    }
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.ini()
      }
    },
    cancelCompleted(val) {
      if (!val) return
      this.completeLoading()
    },
    bulkOperationCompleted(val) {
      if (!val) return
      this.ini()
    }
  }
}
</script>
<style scoped lang="scss">
.inputFormStyle {
  &::v-deep {
    .MultipleSelectSupplierName {
      width: 822px;
    }
  }
}
</style>
